import { render } from "./Permissions.vue?vue&type=template&id=d007f4de&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=d007f4de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d007f4de"]])

export default __exports__